import { useState } from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary, {
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { Box, Typography, Chip, Grid } from "@mui/material";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
      transform: "rotate(90deg)",
    },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export const ExperienceAccordian = (experience) => {
  const [expanded, setExpanded] = useState("panel1");
  console.log("experience", experience);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Box>
      {experience?.experience.map((exp, index) => (
        <Accordion
          key={exp.id}
          expanded={expanded === `panel${index + 1}`}
          onChange={handleChange(`panel${index + 1}`)}
        >
          <AccordionSummary
            aria-controls={`panel${index + 1}d-content`}
            id={`panel${index + 1}d-header`}
          >
            <Grid
              container
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <Typography variant="body1">{exp.company_name}</Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="textSecondary">
                  {exp.start_date} - {exp.end_date || "Present"}
                </Typography>
              </Grid>
            </Grid>
          </AccordionSummary>

          <AccordionDetails>
            <Typography variant="body2" gutterBottom>
              <strong>Project Name:</strong> {exp.project_name}s
            </Typography>
            <Typography variant="body2" gutterBottom>
              <strong>Description:</strong> {exp.description}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <strong>Location:</strong> {exp.location}
            </Typography>
            <Box mt={1}>
              <Typography variant="body2" gutterBottom>
                <strong>Roles:</strong>
              </Typography>
              <Box display="flex" flexWrap="wrap" gap={1}>
                {exp.roles.map((role) => (
                   <Chip clickable={false}
                            onClick={() => {}} key={role.id} label={role.name} />
                ))}
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};
